var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 90,
    viewBox: "0 0 234 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.254 68C119.994 68 132.754 55.2401 132.754 39.5C132.754 23.7599 119.994 11 104.254 11C88.5138 11 75.7539 23.7599 75.7539 39.5C75.7539 55.2401 88.5138 68 104.254 68Z",
    stroke: "#DEDEDE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 86.9995C68.4935 81.0481 74.7298 76.2624 81.7707 72.979C88.8116 69.6956 96.4862 67.9941 104.255 67.9941C112.024 67.9941 119.698 69.6956 126.739 72.979C133.78 76.2624 140.017 81.0481 145.01 86.9995",
    stroke: "#DEDEDE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 22.5,
    r: 22.5,
    fill: "#E5DFF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 22.4004H180.3",
    stroke: "#7544FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.9 11V33.8",
    stroke: "#7544FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.cc08776d2d19ce5e343a6f37765dbd7b.svg";
export { ForwardRef as ReactComponent };